import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import { motion } from "framer-motion";
import Popover from "@mui/material/Popover";
import IRMenu from "./IRMenu";
import AuthorizedCapitalModal from "./AuthorizedCapitalModal";
import IssuedCapitalModal from "./IssuedCapitalModal";
import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";


import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";
import {ReactComponent as EditIcon} from "../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as DownGreyIcon } from "../../../myfin_v2/assets/icons/down_grey.svg";
import { getInvestment } from "../../../WorkSpace/Components/ApiServices/apiHandler";

const ShareCapital = () => {

    const { irId } = useParams();
    const history = useHistory();


    // const authorizedCapitalData = [
    //     {
    //         _id: "1",
    //         classOfShare: "Equity",
    //         numberOfShares: 1000,
    //         faceValue: 10,
    //         amount: 10000
    //     },
    //     {
    //         _id: "2",
    //         classOfShare: "Preference",
    //         numberOfShares: 500,
    //         faceValue: 100,
    //         amount: 50000
    //     },
    //     {
    //         _id: "3",
    //         classOfShare: "Right Issue",
    //         numberOfShares: 200,
    //         faceValue: 10,
    //         amount: 2000
    //     },
    //     {
    //         _id: "4",
    //         classOfShare: "Lease Leability",
    //         numberOfShares: 300,
    //         faceValue: 20,
    //         amount: 6000
    //     }
    // ];

    // const issuedCapitalData = [
    //     {
    //         _id: "1",
    //         shareHolder: "John Doe",
    //         relationship: "Director",
    //         classOfShare: "Equity",
    //         numberOfShares: 5000,
    //         faceValue: 10,
    //         amount: 50000,
    //         holding: "25",
    //     },
    //     {
    //         _id: "2",
    //         shareHolder: "Jane Smith",
    //         relationship: "Investor",
    //         classOfShare: "Preference",
    //         numberOfShares: 3000,
    //         faceValue: 10,
    //         amount: 30000,
    //         holding: "15",
    //     },
    //     {
    //         _id: "3",
    //         shareHolder: "ABC Holdings Pvt Ltd",
    //         relationship: "Promoter",
    //         classOfShare: "Equity",
    //         numberOfShares: 8000,
    //         faceValue: 10,
    //         amount: 80000,
    //         holding: "40",
    //     },
    //     {
    //         _id: "4",
    //         shareHolder: "Ravi Kumar",
    //         relationship: "Employee",
    //         classOfShare: "Right Issue",
    //         numberOfShares: 2000,
    //         faceValue: 10,
    //         amount: 20000,
    //         holding: "10",
    //     },
    //     {
    //         _id: "5",
    //         shareHolder: "XYZ Trust",
    //         relationship: "Affiliate",
    //         classOfShare: "Lease Liability",
    //         numberOfShares: 1000,
    //         faceValue: 10,
    //         amount: 10000,
    //         holding: "5",
    //     },
    // ];

    const classOfShareOptions = ["Equity", "Preference", "Right Issue", "Lease Leability"]
    const relationshipOptions = ["Director","Investor","Promoter","Employee","Affiliate"]

    const [anchorEl, setAnchorEl] = useState(null);
    const [openAuthorizedCapitalPopoverId, setOpenAuthorizedCapitalPopoverId] = useState(null);
    const [selectedAuthorizedCapital, setSelectedAuthorizedCapital] = useState(null);
    const [authorizedModalOpen, setAuthorizedModalOpen] = useState(false)
    const [authorizedModalType, setAuthorizedModalType] = useState(null);
    const [issuedCapitalAnchorEl, setIssuedCapitalAnchorEl] = useState(null);
    const [openIssuedCapitalPopoverId, setOpenIssuedCapitalPopoverId] = useState(null);
    const [selectedIssuedCapital, setSelectedIssuedCapital] = useState(null);
    const [issuedCapitalModalOpen, setIssuedCapitalModalOpen] = useState(false)
    const [issuedCapitalModalType, setIssuedCapitalModalType] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [isIssuedEditing, setIsIssuedEditing] = useState(false);
    const [authorizedCapital, setAuthorizedCapital] = useState([]);
    const [issuedCapital, setIssuedCapital] = useState([]);

    const [editableRows, setEditableRows] = useState([]);
    const [editableIssuedRows, setEditableIssuedRows] = useState([]);




    const handleMenuClick = (event, id) => {
        setAnchorEl(event.currentTarget);
        setOpenAuthorizedCapitalPopoverId(id);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpenAuthorizedCapitalPopoverId(null);
    };

    const handleEdit = (item) => {
        setSelectedAuthorizedCapital(item); // store full row data
        setAuthorizedModalType("edit");
        setAuthorizedModalOpen(true); // open modal
        handleClose(); // close popover
    };


    const handleDelete = (id) => {
        console.log("Delete clicked for:", id);
        handleClose();
        // Add your delete logic here
    };

    const handleModalClose = () => {
        setAuthorizedModalOpen(false);
        setSelectedAuthorizedCapital(null);
        setAuthorizedModalType(null);
    };


    const handleAdd = () => {
        setSelectedAuthorizedCapital(null);
        setAuthorizedModalType("add");
        setAuthorizedModalOpen(true);
    };
  
    const fetchShareCapitalData = async () => {
    try {
    console.log("Fetching Share Capital for ID:", irId);

    const res = await getInvestment(irId);

    if (res.data.success) {
      const authCap =
        res.data.investmentRegister?.authorizedCapital || [];

      const issuedCap =
        res.data.investmentRegister?.issuedCapital || [];

      setAuthorizedCapital(authCap);
      setIssuedCapital(issuedCap);

      setEditableRows(authCap);
      setEditableIssuedRows(issuedCap);
    }
  } catch (error) {
    console.log("Error fetching Share Capital:", error);
  }
};




    const handleIssuedCapitalPopoverClick = (event, id) => {
        setIssuedCapitalAnchorEl(event.currentTarget);
        setOpenIssuedCapitalPopoverId(id);
    };

    const handleIssuedCapitalPopoverClose = () => {
        setIssuedCapitalAnchorEl(null);
        setOpenIssuedCapitalPopoverId(null);
    };

    const handleIssuedCapitalEdit = (item) => {
        setIssuedCapitalModalType("edit");
        setSelectedIssuedCapital(item);
        setIssuedCapitalModalOpen(true);
        handleIssuedCapitalPopoverClose();
    };

    const handleIssuedCapitalDelete = (item) => {
        handleIssuedCapitalPopoverClose();
    };

    const handleAddIssuedCapital = () => {
        setSelectedIssuedCapital(null);
        setIssuedCapitalModalType("add");
        setIssuedCapitalModalOpen(true);
    };

    const handleIssuedCapitalModalClose = () => {
        setIssuedCapitalModalOpen(false);
        setSelectedIssuedCapital(null);
        setIssuedCapitalModalType(null);
    };


   const handleAuthorizedChange = (id, field, value) => {
    setEditableRows((prev) =>
        prev.map((row) =>
        row._id === id ? { ...row, [field]: value } : row
        )
    );
    };

 const handleIssuedChange = (id, field, value) => {
  setEditableIssuedRows((prev) =>
    prev.map((row) =>
      row._id === id ? { ...row, [field]: value } : row
    )
  );
};


    const open = Boolean(anchorEl);

  useEffect(() => {
  if (irId) fetchShareCapitalData();
}, [irId]);

    return (
        <>
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu
                    activeTab={"Share Capital"}
                    registerID={irId}
                />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >
                    <div className={investmentRegisterCss.iRHeader}>
                        {/* <Button
                            btnColor={buttoncss.primary}
                            icon={<PlusIcon />}
                            label="Create Investment"
                            onClick={() => { history.push(`/create-investment/${irId}`) }}
                        /> */}
                    </div>

                    <div className={investmentRegisterCss.tableLayout}>
                        <div className={investmentRegisterCss.tableConatiner}>
                            <div className={investmentRegisterCss.tableTitle}>
                                <span>Authorized Capital</span>
                               {!isEditing && (
                                <span className="d-flex gap-1">
                                    <Button
                                    btnColor={buttoncss.greyBg}
                                    icon={<EditIcon />}
                                    class_={investmentRegisterCss.editBtn}
                                    onClick={() => setIsEditing(true)}
                                    />

                                    <Button
                                    btnColor={buttoncss.greyBg}
                                    icon={<PlusPrimaryIcon />}
                                    class_={investmentRegisterCss.addBtnRow}
                                    onClick={handleAdd}
                                    />
                                </span>
                                )}

                               {isEditing && (
                                <div className={investmentRegisterCss.saveCancelWrap}>
                                    <button
                                    className={investmentRegisterCss.cancelBtn}
                                    onClick={() => {
                                        setIsEditing(false);
                                        setEditableRows([...authorizedCapital]);
                                    }}
                                    >
                                    Cancel
                                    </button>

                                    <button
                                    className={investmentRegisterCss.saveBtn}
                                    onClick={() => {
                                        console.log("Saved Data:", editableRows);
                                        setIsEditing(false);
                                    }}
                                    >
                                    Save
                                    </button>
                                </div>
                                )}

                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "left", paddingLeft: "20px" }}>Class of share</th>
                                        <th style={{ textAlign: "right" }}>Number of shares</th>
                                        <th style={{ textAlign: "right" }}>Face value</th>
                                        <th style={{ textAlign: "right" }}>Amount</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                   {editableRows.map((item) => (

                                        <tr key={item._id}>
                                          <td style={{ textAlign: "left", paddingLeft: "20px" }}>
                                            {isEditing ? (
                                                <div className={investmentRegisterCss.dropdownWrapper}>
                                                <select
                                                    className={investmentRegisterCss.dropdownInput}
                                                    value={item.classOfShare}
                                                    onChange={(e) =>
                                                    handleAuthorizedChange(
                                                        item._id,
                                                        "classOfShare",
                                                        e.target.value
                                                    )
                                                    }
                                                >
                                                    <option value="" disabled>
                                                    Select class of share
                                                    </option>

                                                    {classOfShareOptions.map((opt) => (
                                                    <option key={opt} value={opt}>
                                                        {opt}
                                                    </option>
                                                    ))}
                                                </select>

                                                <span className={investmentRegisterCss.dropdownArrow}>
                                                    <DownGreyIcon />
                                                </span>
                                                </div>
                                            ) : (
                                                item.classOfShare
                                            )}
                                            </td>


                                            <td style={{ textAlign: "right" }}>
                                            {isEditing ? (
                                                <input
                                                type="number"
                                                value={item.noOfShares}
                                                className={investmentRegisterCss.inputShare}
                                                onChange={(e) =>
                                                    handleAuthorizedChange(item._id, "noOfShares", e.target.value)
                                                }
                                                placeholder="Enter Number..."
                                                />
                                            ) : (
                                                item.noOfShares
                                            )}
                                            </td>

                                             <td style={{ textAlign: "right" }}>
                                                {isEditing ? (
                                                    <input
                                                    type="number"
                                                    className={investmentRegisterCss.inputShare}
                                                    value={item.faceValue}
                                                    onChange={(e) =>
                                                        handleAuthorizedChange(item._id, "faceValue", e.target.value)
                                                    }
                                                    placeholder="Enter Value..."
                                                    />
                                                ) : (
                                                    item.faceValue
                                                )}
                                                </td>

                                             <td style={{ textAlign: "right" }}>
                                                {isEditing ? (
                                                    <input
                                                    type="number"
                                                    className={investmentRegisterCss.inputShare}
                                                    value={item.amount}
                                                    onChange={(e) =>
                                                        handleAuthorizedChange(item._id, "amount", e.target.value)
                                                    }
                                                    placeholder="Enter Amount..."
                                                    />
                                                ) : (
                                                    item.amount
                                                )}
                                                </td>

                                            <td>
                                                <MenuDotsIcon
                                                    style={{ cursor: "pointer", marginRight: 20 }}
                                                    onClick={(e) => handleMenuClick(e, item._id)}
                                                />
                                                <Popover
                                                    open={open && openAuthorizedCapitalPopoverId === item._id}
                                                    anchorEl={anchorEl}
                                                    onClose={handleClose}
                                                    anchorOrigin={{
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    }}

                                                >
                                                    <div className={investmentRegisterCss.irOptions}>
                                                        <span
                                                            style={{ borderBottom: "1px solid #EAEEED" }}
                                                            onClick={() => handleEdit(item)}
                                                        >
                                                            Edit
                                                        </span>
                                                        <span onClick={() => handleDelete(item._id)}>Delete</span>
                                                    </div>

                                                </Popover>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className={investmentRegisterCss.tableConatiner}>
                            <div className={investmentRegisterCss.tableTitle}>
                                <span>Issued Capital</span>
                                {!isIssuedEditing && (
                                <span className="d-flex gap-1">
                                    <Button
                                    btnColor={buttoncss.greyBg}
                                    icon={<EditIcon />}
                                    class_={investmentRegisterCss.editBtn}
                                    onClick={() => setIsIssuedEditing(true)}
                                    />

                                    <Button
                                    btnColor={buttoncss.greyBg}
                                    icon={<PlusPrimaryIcon />}
                                    class_={investmentRegisterCss.addBtnRow}
                                    onClick={handleAddIssuedCapital}
                                    />
                                </span>
                                )}

                                    {isIssuedEditing && (
                                    <div className={investmentRegisterCss.saveCancelWrap}>
                                        <button
                                        className={investmentRegisterCss.cancelBtn}
                                        onClick={() => {
                                            setIsIssuedEditing(false);
                                            setEditableIssuedRows([...issuedCapital]);
                                        }}
                                        >
                                        Cancel
                                        </button>

                                        <button
                                        className={investmentRegisterCss.saveBtn}
                                        onClick={() => {
                                            console.log("Issued Capital Saved:", editableIssuedRows);
                                            setIsIssuedEditing(false);
                                        }}
                                        >
                                        Save
                                        </button>
                                    </div>
                                    )}

                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: "left", paddingLeft: "20px" }}>Share holder</th>
                                        <th>Relationship</th>
                                        <th>Class of Share</th>
                                        <th style={{ textAlign: "right" }}>No of shares</th>
                                        <th style={{ textAlign: "right" }}>Face value</th>
                                        <th style={{ textAlign: "right" }}>Amount</th>
                                        <th style={{ textAlign: "right" }}>Holding</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {editableIssuedRows.map((item) => (
                                        <tr key={item._id}>
                                            <td style={{ textAlign: "left", paddingLeft: "20px" }}>{item.shareHolder}</td>
                                           <td>
                                            {isIssuedEditing ? (
                                                <div className={investmentRegisterCss.dropdownWrapper}>
                                                <select
                                                    className={investmentRegisterCss.dropdownInput}
                                                    value={item.relationship}
                                                    onChange={(e) =>
                                                    handleIssuedChange(item._id, "relationship", e.target.value)
                                                    }
                                                >
                                                    {relationshipOptions.map((opt) => (
                                                    <option key={opt} value={opt}>
                                                        {opt}
                                                    </option>
                                                    ))}
                                                </select>

                                                <span className={investmentRegisterCss.dropdownArrow}>
                                                    <DownGreyIcon />
                                                  </span>
                                                </div>
                                            ) : (
                                                item.relationship
                                            )}
                                            </td>

                                            <td>
                                            {isIssuedEditing ? (
                                                <div className={investmentRegisterCss.dropdownWrapper}>
                                                <select
                                                    className={investmentRegisterCss.dropdownInput}
                                                    value={item.classOfShare}
                                                    onChange={(e) =>
                                                    handleIssuedChange(item._id, "classOfShare", e.target.value)
                                                    }
                                                >
                                                    {classOfShareOptions.map((opt) => (
                                                    <option key={opt} value={opt}>
                                                        {opt}
                                                    </option>
                                                    ))}
                                                </select>

                                                <span className={investmentRegisterCss.dropdownArrow}>
                                                    <DownGreyIcon />
                                                </span>
                                                </div>
                                            ) : (
                                                item.classOfShare
                                            )}
                                            </td>

                                            <td style={{ textAlign: "right" }}>
                                            {isIssuedEditing ? (
                                                <input
                                                type="number"
                                                className={investmentRegisterCss.inputShare}
                                                value={item.noOfShares}
                                                placeholder="Enter Number..."
                                                onChange={(e) =>
                                                    handleIssuedChange(item._id, "noOfShares", e.target.value)
                                                }
                                                />
                                            ) : (
                                                item.noOfShares
                                            )}
                                            </td>

                                            <td style={{ textAlign: "right" }}>
                                            {isIssuedEditing ? (
                                                <input
                                                type="number"
                                                className={investmentRegisterCss.inputShare}
                                                value={item.faceValue}
                                                placeholder="Enter Values..."
                                                onChange={(e) =>
                                                    handleIssuedChange(item._id, "faceValue", e.target.value)
                                                }
                                                />
                                            ) : (
                                                item.faceValue
                                            )}
                                            </td>

                                            <td style={{ textAlign: "right" }}>
                                            {isIssuedEditing ? (
                                                <input
                                                type="number"
                                                className={investmentRegisterCss.inputShare}
                                                value={item.amount}
                                                placeholder="Enter Amount..."
                                                onChange={(e) =>
                                                    handleIssuedChange(item._id, "amount", e.target.value)
                                                }
                                                />
                                            ) : (
                                                item.amount
                                            )}
                                            </td>

                                            <td style={{ textAlign: "right" }}>
                                            {isIssuedEditing ? (
                                                <input
                                                type="number"
                                                className={investmentRegisterCss.inputShare}
                                                value={item.holdingPercentage}
                                                placeholder="Enter Holding %..."
                                                onChange={(e) =>
                                                    handleIssuedChange(item._id, "holdingPercentage", e.target.value)
                                                }
                                                />
                                            ) : (
                                                item.holdingPercentage
                                            )}
                                            </td>

                                            <td>
                                                <MenuDotsIcon
                                                    style={{ cursor: "pointer" }}
                                                    onClick={(e) => handleIssuedCapitalPopoverClick(e, item._id)}
                                                />
                                                <Popover
                                                    open={openIssuedCapitalPopoverId === item._id}
                                                    anchorEl={issuedCapitalAnchorEl}
                                                    onClose={handleIssuedCapitalPopoverClose}
                                                    anchorOrigin={{
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    }}

                                                >
                                                    <div className={investmentRegisterCss.irOptions}>
                                                        <span
                                                            style={{ borderBottom: "1px solid #EAEEED" }}
                                                            onClick={() => handleIssuedCapitalEdit(item)}
                                                        >
                                                            Edit
                                                        </span>
                                                        <span onClick={() => handleIssuedCapitalDelete(item)}>Delete</span>
                                                    </div>

                                                </Popover>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </motion.div>
            </div>
            
            {isEditing && (
            <tr>
                <td colSpan="5">
                <button
                    className={investmentRegisterCss.addRowBtn}
                    onClick={() =>
                    setEditableRows((prev) => [
                        ...prev,
                        {
                        _id: Date.now().toString(),
                        classOfShare: "",
                        noOfShares: "",
                        faceValue: "",
                        amount: "",
                        },
                    ])
                    }
                >
                    + Add New Row
                </button>
                </td>
            </tr>
            )}

            {authorizedModalOpen && (
                <AuthorizedCapitalModal
                    handleClose={handleModalClose}
                    data={selectedAuthorizedCapital}
                    type={authorizedModalType}
                    classOfShareOptions={classOfShareOptions}
                    investmentID= {irId}
                    refreshData={fetchShareCapitalData}
                />
            )}

            {issuedCapitalModalOpen && (
                <IssuedCapitalModal
                    handleClose={handleIssuedCapitalModalClose}
                    data={selectedIssuedCapital}
                    type={issuedCapitalModalType}
                    classOfShareOptions={classOfShareOptions}
                    relationshipOptions={relationshipOptions}
                    investmentID= {irId}
                    refreshData={fetchShareCapitalData}
                />
            )}

        </>
    )
}

export default ShareCapital;